import React from 'react';
import { Button } from '@legalshield/adonis-ux-framework';

type NavRowProps = {
  onBack?: () => void;
  onCancelEdit?: () => void;
  onSubmit: () => void;
  submitLabel: string;
  submitting?: boolean;
  disabled?: boolean;
};

const NavRow = ({ onBack, onCancelEdit, onSubmit, submitLabel, submitting, disabled }: NavRowProps) => (
  <div className="rnq-navrow">
    <div className="rnq-navrow__left">
      {onBack && <Button label="Back" variant="standard" onClick={onBack} />}
      {onCancelEdit && <Button label="Cancel" variant="standard" onClick={onCancelEdit} />}
    </div>
    <div className="rnq-navrow__right">
      <Button label={submitLabel} variant="primary" disabled={submitting || disabled} onClick={onSubmit} />
    </div>
  </div>
);

export default NavRow;
